import type { Briefing, PageType } from "@/lib/api/types";

export const PAGE_TYPES: { value: PageType; label: string }[] = [
  { value: "ratgeber", label: "Ratgeber-Artikel" },
  { value: "landingpage", label: "Landingpage" },
  { value: "produktseite", label: "Produktseite" },
];

export const MARKETS = [
  { value: "DE", label: "Deutschland (DE)" },
  { value: "AT", label: "Österreich (AT)" },
  { value: "CH", label: "Schweiz (CH)" },
];

export function pageTypeLabel(type: PageType): string {
  return PAGE_TYPES.find((t) => t.value === type)?.label ?? type;
}

// Schritte des Wizards (Mockup Briefing). `session` = Session, in der der Schritt gebaut wird (docs/BACKLOG.md)
export const STEPS = [
  { label: "Eingabe", sub: "Keyword & Optionen", session: "S06" },
  { label: "Keywords", sub: "ahrefs", session: "S07" },
  { label: "Prompts generieren", sub: "ahrefs + Gemini", session: "S08" },
  { label: "Query-Fan-outs", sub: "ChatGPT + Gemini", session: "S09" },
  { label: "Quellen-Analyse", sub: "Crawl & Entitäten", session: "S10" },
  { label: "Themen & Fragestellungen", sub: "Unter-Themen & Outline", session: "S11" },
] as const;

/** „Abgeschlossen“ oder „Entwurf · Schritt 2“ (Schritt 0 = Eingabe). */
export function statusLabel(briefing: Pick<Briefing, "status" | "current_step">): string {
  return briefing.status === "done" ? "Abgeschlossen" : `Entwurf · Schritt ${briefing.current_step}`;
}

/** Schritt, in dem ein Briefing beim Öffnen landet: abgeschlossen → Schritt 5 (dort liegt die Outline), Entwurf → letzter Schritt. */
export function openingStep(briefing: Pick<Briefing, "status" | "current_step">): number {
  return briefing.status === "done" ? 5 : briefing.current_step;
}
